export default __webpack_public_path__ + "9a29cae34996e714d0239d07e4cfd8b9.png";